import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M.558 9.333h30.91c.424 2.295.556 4.592.529 6.684a34.3 34.3 0 0 1-.556 6.65H.546c-.439-2.307-.57-4.598-.543-6.684a34.3 34.3 0 0 1 .555-6.65",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M2.694 4.04 10.667 16 2.694 27.96C1.276 26.08.866 24.123.866 24.123c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 .41-1.956 1.828-3.834",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "m16.667 17.333-1.96 1.364.692-2.285-1.902-1.442 2.386-.049.784-2.254.784 2.254 2.386.049-1.902 1.442.691 2.285zm8 0-1.96 1.364.692-2.285-1.902-1.442 2.386-.049.784-2.254.784 2.254 2.386.049-1.902 1.442.691 2.285z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagStp = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagStp_default = SvgFlagStp;

export { FlagStp_default as default };
